// Perfiles de TurnosIA forzados a /turnos (feat_273). Fuente única compartida por
// Route.js y el diálogo de cierre del chat flotante (modo turnos).
export const TURNOS_PROFILES = ["profesional", "agendador"];

export const isTurnosProfile = (profile) => TURNOS_PROFILES.includes(profile);
